var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1840_3292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.76953 7.94922L25.7303 26.0507",
    stroke: "#A6C2FF",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5368 5.06362C25.7062 11.0586 23.9457 11.4084 21.8746 11.9815C21.432 14.0017 20.3038 16.6134 17.6379 19.3545L7.31781 28.8528L5.30229 26.8926L15.6224 17.3943C17.4695 15.495 18.406 13.7212 18.8626 12.2666C16.3054 12.0403 14.089 10.6529 13.2859 8.6929C12.6403 7.12456 13.0104 5.46668 14.297 4.14378C15.9588 2.43514 18.3311 2.41545 20.0656 4.10231C21.2357 5.2403 21.9569 6.97059 22.1024 8.90921C23.6019 8.24371 24.7633 7.9956 29.5213 3.10339L31.5368 5.06362ZM19.2557 9.40796C19.1778 7.87067 18.606 6.76706 18.0242 6.20124C17.8237 6.00628 16.8508 5.24543 16.0431 6.07592C15.2353 6.90642 15.9949 7.79081 16.2716 8.05995C16.7531 8.52828 17.8657 9.39844 19.2557 9.40796Z",
    fill: "#A6C2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1840_3292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadX);
export default __webpack_public_path__ + "static/media/upload-x.70c68c1cfcff9c9b1c0530e8d164d4f6.svg";
export { ForwardRef as ReactComponent };